/**
 * The lecturers shown in the landing page's "Učite od ljudi iz prakse" grid,
 * in the order they appear.
 *
 * `name` must match the `name` field on the lecturer exactly as the API returns
 * it, diacritics included — a name that matches nothing is skipped, so the grid
 * would quietly render three cards instead of four.
 *
 * Four rather than five: the grid is a fixed four columns now.
 *
 * ---------------------------------------------------------------------------
 * TODO: zamijeniti stvarnim titulama.
 *
 * `role` is the line under the name, and it is the whole point of the section:
 * the heading promises people from practice, so the card has to say what they
 * actually do. The API gives us nothing but `name` and `picture_url`, so these
 * lines were written from the courses each person teaches and nothing else —
 * no employers, no titles, no institutions, because inventing credentials for
 * a named person is not a thing a placeholder gets to do. Replace them with
 * the real ones. A missing `role` falls back to the lecturer's categories.
 *
 * `role` is stored as a translation key (`landing:lecturers.<name>.role`), which
 * the grid runs through `t()`. The wording, in both languages, lives in
 * locales/<language>/landing.json — that is where the real titles go.
 * ---------------------------------------------------------------------------
 *
 * `focus` is the portrait's `object-position`. Every source image is a 1080²
 * square dropped into a 4:5 frame, so the crop only ever eats width — the
 * vertical half is carried for the day a non-square portrait shows up. Faces
 * do not sit dead centre in these photographs, hence one value per person.
 */
export const FEATURED_LECTURERS = [
	{
		name: "Adisa Omerbegović-Arapović",
		role: "landing:lecturers.adisa.role",
		focus: "55% 50%",
	},
	{
		name: "Jasmin Alić",
		role: "landing:lecturers.jasmin.role",
		focus: "55% 50%",
	},
	{
		name: "Dino Kečo",
		role: "landing:lecturers.dino.role",
		focus: "50% 50%",
	},
	{
		name: "Mirza Hasanefendić",
		role: "landing:lecturers.mirza.role",
		focus: "48% 50%",
	},
];
